import ConnectedAccountTransactionHistory from './ConnectedAccountTransactionHistory';

export default ConnectedAccountTransactionHistory;
